import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { veTokenAbi } from "@/domains/abis"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type TransferLockProps = {
  chainId: number
  config: Config
  vestedAddress: Address
  account: Address
  toAccount: Address
  tokenId: number
}

export const transferLock = async ({
  chainId,
  config,
  vestedAddress,
  account,
  toAccount,
  tokenId,
}: TransferLockProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veTokenAbi as Abi,
        account,
        address: vestedAddress,
        args: [account, toAccount, tokenId],
        chainId,
        functionName: "transferFrom",
      },
    })
    return result
  } catch (error: any) {
    console.error("transferLock", error)
    return { success: false, error: error.message, code: error.code }
  }
}
